import Vue from 'vue';
import VueResource from 'vue-resource';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

export default {
  arquivos: id => {
    return Vue.http.get(`/api/protocolo/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
      return Vue.http.get(`/api/protocolo/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/protocolo/servico.js